import { makeSelectors, combineTokens } from '@utils/css';

const tokens = combineTokens("--split-page", {
  paddingTop: "0px",
  paddingBottom: "0px"
});
const templateContainer = "_7ct1vfd2ar";
const page = "_7cp13c8ijb";
const paddingTop = "_7cp1uwjdcx";
const paddingBottom = "_7cp16rp83v";
const pageContent = "_7cp1dv7iqw";
const content = "_7ccprfr7d";
const footer = "_7cfeqmto6";
const lineCounter = "_7cl1my0ygs";
const pageSelectors = makeSelectors({
  page,
  pageContent,
  content,
  paddingTop,
  paddingBottom,
  header: "page--header",
  footer,
  includeInLineCount: "includeInLineCount"
});

export { content, footer, lineCounter, paddingBottom, paddingTop, page, pageContent, pageSelectors, templateContainer, tokens };
import "./_split-pages.style.linaria.module.css";
//# sourceMappingURL=_split-pages.style.js.map
